export default __webpack_public_path__ + "static/media/logo verdemi_11zon.55f49c55.webp";